'use strict';

(function () {
  var menu = document.querySelector('.menu--header');
  var menuTrigger = document.querySelector('.menu__trigger');

  if (!menuTrigger && !menu) {
    return;
  }

  var body = document.body; // eslint-disable-line prefer-destructuring
  var lastMenuItem = menu.querySelector('.menu__item:last-of-type');
  var button = menu.querySelector('.menu__item.is-button-on-sm');

  var showMenuMain = function showMenuMain() {
    body.classList.toggle('js-menu-is-visible');
  };

  // click
  menuTrigger.addEventListener('click', showMenuMain);

  // space or return
  menuTrigger.addEventListener('keydown', function (e) {
    if (e.keyCode == 13 || e.keyCode == 32) {
      showMenuMain();
      e.preventDefault();
    }
  });

  // tab last item menu
  lastMenuItem.addEventListener('keydown', function (e) {
    if (e.keyCode === 9) {
      body.classList.remove('js-menu-is-visible');
    }
  });

  // move alt button
  if (button) {
    menu.appendChild(button);
  }
})();